package pl.decks.personal.components.widgets.ranks.shapes

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.CSSTimeNumericValue
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.dom.svg.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.vars.animation.TransitionDurationVars

@Composable
fun Battery(
    backgroundColor: Color = Colors.DarkSlateBlue,
    strokeColor: Color? = null,
    strokeWidth: Float = 10f,
    cornerRadius: Float = 8f,
    capWidth: Float = 0.4f,
    capHeight: Float = 0.08f,
    transitionDur: CSSTimeNumericValue = TransitionDurationVars.Slow.value(),
    modifier: Modifier = Modifier,
) {
    val width = 100f
    val height = 100f
    val resolvedStroke = strokeColor ?: backgroundColor

    Svg(
        attrs = Modifier
            .fillMaxSize()
            .overflow(Overflow.Visible)
            .then(modifier)
            .toAttrs {
                attr("viewBox", "0 0 $width $height")
                attr("preserveAspectRatio", "none")
            }
    ) {
        Defs {
            Filter(id = SvgId("battery-shadow")) {
                DropShadow {
                    attr("dx", "2")
                    attr("dy", "2")
                    attr("stdDeviation", "4")
                    attr("flood-color", "rgba(0,0,0,0.5)")
                }
            }
        }
        Rect {
            attr("x", (width * (1 - capWidth) / 2).toString())
            attr("y", "0")
            attr("width", (width * capWidth).toString())
            attr("height", (height * capHeight).toString())
            attr("rx", (cornerRadius * 0.5f).toString())
            attr("fill", strokeColor.toString())
            style {
                property("transition", "fill $transitionDur")
            }
        }
        Rect {
            attr("x", "0")
            attr("y", (height * capHeight).toString())
            attr("width", width.toString())
            attr("height", (height * (1f - capHeight)).toString())
            attr("rx", cornerRadius.toString())
            attr("fill", backgroundColor.toString())
            attr("stroke", resolvedStroke.toString())
            attr("stroke-width", strokeWidth.toString())
            attr("filter", "url(#battery-shadow)")
            style {
                property("transition", "fill $transitionDur, stroke $transitionDur")
            }
        }
    }
}
